export default {
  'get-list': {
    method: 'post',
    url: '/client/driver/license/list/ID'
  },
  add: {
    method: 'post',
    url: '/client/driver/license'
  },
  delete: {
    method: 'delete',
    url: '/client/driver/license'
  },
  get: {
    method: 'get',
    url: '/client/driver/license/ID'
  },
  edit: {
    method: 'put',
    url: '/client/driver/license/ID'
  },
  archive: {
    method: 'delete',
    url: '/client/driver/license/archive'
  },
  restore: {
    method: 'put',
    url: '/client/driver/license/restore'
  }
}
